module.exports = "<div class=\"modal-spinner\" [@spinner-visibility]=\"spinnerVisibility\">\n  <div class=\"spinner\"></div>\n</div>"